import { Pipe, PipeTransform } from '@angular/core';

import * as numeral from 'numeral';

/*
 * Formats big numbers
 * Takes a number and shortens it
 * Usage:
 *   value | shortNumber
 * Example:
 *   {{ 1500000 | shortNumber }}
 *   formats to: 1.5m
 */
@Pipe({ name: 'shortNumber' })
export class ShortNumberPipe implements PipeTransform {
  transform(value: any): any {
    // let output: any;
    let output: any = numeral(value).format('0.[0]a');

    return output;
  }
}
